import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";

interface OtpSubheaderProps {
  email?: string;
  emailSuffix?: string;
  showSecureAccountCopy?: boolean;
  showTitle: boolean;
  title?: string;
}

export const OtpSubheader = ({
  email,
  emailSuffix,
  showTitle,
  showSecureAccountCopy = false,
  title,
}: OtpSubheaderProps) => (
  <div className="flex flex-col gap-2">
    {showTitle && (
      <Typography.BodySm weight="font-bold">
        {title ??
          (showSecureAccountCopy
            ? t("otp_challenge_modal.enter_verification_code")
            : t("otp_challenge_modal.verification_required"))}
      </Typography.BodySm>
    )}
    <Typography.BodySm>
      {t("otp_challenge_modal.enter_code_sent_to")}&nbsp;
      {email && (
        <Typography.LabelSm as="span" weight="medium">
          {email}
        </Typography.LabelSm>
      )}
      {emailSuffix}
      {showSecureAccountCopy && (
        <>&nbsp;{t("otp_challenge_modal.enter_code_sent_to_secure_suffix")}</>
      )}
    </Typography.BodySm>
  </div>
);

OtpSubheader.displayName = "OtpSubheader";
